import thunk from "redux-thunk";

import crashReporter from "./crashReporter";
import router from "./router";

export const productionMiddleware = [crashReporter, thunk, router];

export const testsMiddleware = [crashReporter, thunk];
